const steps = [
  { num: 1, title: 'Browse', desc: 'Explore categorized spreadsheets organized by product type and niche' },
  { num: 2, title: 'Compare', desc: 'Evaluate products side by side using structured data and supplier info' },
  { num: 3, title: 'Identify', desc: 'Pinpoint winning suppliers faster with organized sourcing intelligence' },
  { num: 4, title: 'Scale', desc: 'Redirect to the platform and grow your online business efficiently' },
];

export default function HowItWorks() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" id="how-it-works">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          {/* Left - Label */}
          <div className="lg:w-1/3">
            <span className="text-xs font-medium text-foreground-500 tracking-widest uppercase">
              / How It Works
            </span>
            <span className="block mt-6 text-xs text-foreground-400 font-medium">· Simple Process</span>
          </div>

          {/* Right - Title */}
          <div className="lg:w-2/3">
            <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 font-light leading-[1.25]">
              Sourcing in 4 Steps
            </h2>
          </div>
        </div>

        {/* Steps */}
        <div className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {steps.map((step) => (
            <div key={step.num} className="flex flex-col items-start">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-primary-100 flex items-center justify-center mb-4">
                <span className="font-heading text-xl md:text-2xl font-bold text-primary-700">{step.num}</span>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{step.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}